import dedent from 'ts-dedent'
import {
  ColumnDataType,
  GetOutputSchemaParams,
  Provider,
  TableSchema,
  WorkflowComponentCodeParams,
  WorkflowComponentParamType
} from '../types'
import { addColumns } from '../utils/schemas'
import { SelectWorkflowComponent } from './common/selectcomponent'

class Distance extends SelectWorkflowComponent {
  constructor() {
    super(
      {
        name: 'native.stdistance',
        group: 'Spatial Operations',
        title: 'ST Distance',
        description: `
      This component calculates the distance between geographies of an input table
      and those of a second table that match a given criteria to join them .
      `,
        starred: true
      },
      [
        {
          name: 'main',
          type: WorkflowComponentParamType.InputTable,
          title: 'Main table'
        },
        {
          name: 'secondary',
          type: WorkflowComponentParamType.InputTable,
          title: 'Secondary table'
        },
        {
          name: 'geomain',
          type: WorkflowComponentParamType.Column,
          title: 'Geo column in main table',
          parent: 'main',
          dataType: [ColumnDataType.Geography, ColumnDataType.Geometry]
        },
        {
          name: 'geosecondary',
          type: WorkflowComponentParamType.Column,
          title: 'Geo column in secondary table',
          parent: 'secondary',
          dataType: [ColumnDataType.Geography, ColumnDataType.Geometry]
        },
        {
          name: 'joinmain',
          type: WorkflowComponentParamType.Column,
          title: 'Column in main table for joining',
          parent: 'main'
        },
        {
          name: 'joinsecondary',
          type: WorkflowComponentParamType.Column,
          title: 'Column in secondary table for joining',
          parent: 'secondary'
        }
      ]
    )
  }

  getInnerSql({ params, connection, envVars }: WorkflowComponentCodeParams) {
    if (connection.type === Provider.DatabricksRest) {
      return dedent`
        SELECT  /*+ REPARTITION(40) */
          a.*,
          b.${params.geosecondary} AS ${params.geosecondary}_joined,
          ST_Distance(
            ${connection.processInputGeogColumn(`a.${params.geomain}`)},
            ${connection.processInputGeogColumn(`b.${params.geosecondary}`)}
          ) AS distance
        FROM
          ${connection.quoteName(params.main as string)} a,
          ${connection.quoteName(params.secondary as string)} b
        WHERE a.${params.joinmain} = b.${params.joinsecondary}`
    } else {
      return dedent`
        SELECT
          a.*,
          b.${params.geosecondary} AS ${params.geosecondary}_joined,
          ST_Distance(
            ${connection.processInputGeogColumn(`a.${params.geomain}`)},
            ${connection.processInputGeogColumn(`b.${params.geosecondary}`)}
          ) AS distance
        FROM
          ${connection.quoteName(params.main as string)} a,
          ${connection.quoteName(params.secondary as string)} b
        WHERE a.${params.joinmain} = b.${params.joinsecondary}`
    }
  }

  canProvideOutputSchemas(): boolean {
    return true
  }

  getOutputSchema({ columns, params, connection }: GetOutputSchemaParams): TableSchema {
    return addColumns(columns.main, [
      { name: 'distance', type: ColumnDataType.Number },
      {
        name: `${params.geosecondary}_joined`,
        type: connection.getGeoDataType()
      }
    ])
  }
  supportedProviders(): Provider[] {
    return [Provider.BigQuery, Provider.Postgres, Provider.Redshift, Provider.Snowflake, Provider.DatabricksRest]
  }
}

export { Distance }
